module.exports = __webpack_public_path__ + "img/cosa.56392413.jpg";